import { createContext, useContext } from 'react';

type LayoutContextProps = {
  sidebarCollapsed: boolean;
  toggleSidebarMode: () => void;
  allowExpandedSidebar: boolean;
  sidebarTransitionEnded: boolean;
};

const LayoutContext = createContext<LayoutContextProps | null>(null);

export const LayoutContextProvider = LayoutContext.Provider;

export function useLayoutContext() {
  const context = useContext(LayoutContext);
  if (!context) {
    throw new Error(
      'useLayoutContext must be used within a LayoutContextProvider',
    );
  }
  return context;
}
